module.exports = __webpack_public_path__ + "assets/img/websummit.70c47325.png";